function toFixed2(value) {  // 转日期一定要记得 月份 + 1
    return value.toFixed(2)
}


export default toFixed2;


// WEBPACK FOOTER //
// ./src/mixins/filters/toFixed.js